import React from "react";

import type { Operation } from "./types";

export type CheckOperationCotext = {
	operation: string | string[];
	operations: Operation[];
	passed: boolean;
};

export const FormFieldContext = React.createContext<CheckOperationCotext>(
	{} as CheckOperationCotext,
);
